import { makeStyles } from "tss-react/mui";
import { MiButton, MiStepper } from "@miplatform/components";
import { BUTTON_VARIANTS } from "@miplatform/constants";
import { mdiArrowLeft, mdiArrowRight } from "@mdi/js";
import { Box } from "@mui/material";

/**
 * A custom stepper component for rendering step-by-step navigation with customizable actions and buttons.
 * @param {object} props
 * @param {React.ReactNode} props.children
 * @param {number} props.activeStep
 * @param {function} props.setActiveStep
 * @param {object[]} props.steps
 * @param {Array<object>} props.actions
 * @param {string} props.backLabel
 * @param {string} props.nextLabel
 * @returns {JSX.Element}
 */

export function StepperView({
  children,
  activeStep = 0,
  setActiveStep = () => null,
  disabled,
  disableNavigation = false,
  steps = [{ value: 0, label: "" }],
  nextLabel = "",
  customLeftBtn,
}) {
  const { classes } = useStyles();

  const handleNext = () => {
    setActiveStep(activeStep + 1);
  };

  const handleBack = () => {
    setActiveStep(activeStep - 1);
  };

  return (
    <>
      {children}
      <Box className={classes.btnContainer}>
        <Box className={classes.submitBtnContainer}>{customLeftBtn}</Box>
        <MiStepper
          activeStep={activeStep}
          steps={steps}
          setActiveStep={setActiveStep}
          disabled={disableNavigation}
        />
        <Box className={classes.submitBtnContainer}>
          {activeStep !== steps[0]?.value && (
            <MiButton
              title="Back"
              onClick={handleBack}
              className={classes.backBtn}
              size="small"
              startIcon={{ path: mdiArrowLeft }}
            />
          )}
          <MiButton
            variant={BUTTON_VARIANTS.CONTAINED}
            title={nextLabel}
            onClick={handleNext}
            endIcon={
              activeStep !== steps[steps.length - 1].value
                ? { path: mdiArrowRight }
                : null
            }
            disabled={disabled}
          />
        </Box>
      </Box>
    </>
  );
}

const useStyles = makeStyles()((theme) => ({
  btnContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: 8,
    borderTop: `1px solid ${theme.palette.grey.accent}`,
    backgroundColor: theme.palette.common.white,
  },
  submitBtnContainer: {
    display: "flex",
    gap: 8,
  },
  backBtn: {
    color: theme.palette.primary.main,
    border: `1px solid ${theme.palette.primary.main}`,
  },
}));
